<template>
  <v-container class="fill-height py-0" fluid>
    <v-row class="fill-height">
      <v-col class="pa-0">
        <v-sheet height="64">
          <v-toolbar flat height="60" class="pt-1">
            <v-btn
              v-blur
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Oggi
            </v-btn>
            <!-- Bottone di selezione del tipo di calendario -->
            <v-menu bottom right v-if="$store.state.permessi >= 8">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{
                    tipi_calendario[$store.state.tipo_calendario]
                  }}</span>
                  <v-icon right> mdi-menu-down </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="$store.state.tipo_calendario = 'category'">
                  <v-list-item-title>Comparti</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$store.state.tipo_calendario = 'week'">
                  <v-list-item-title>Settimana</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn v-blur fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn v-blur fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-toolbar-title class="d-flex align-center" v-if="$refs.calendar">
              {{
                $store.state.tipo_calendario == "category"
                  ? `${calendar_date.day} ${mesi[calendar_date.month - 1]} ${
                      calendar_date.year
                    }`
                  : $refs.calendar.title
              }}

              <!-- Date picker per scegliere la data -->
              <v-menu
                v-model="date_picker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-calendar</v-icon>
                  </v-btn>
                </template>
                <v-date-picker
                  v-model="calendar"
                  @input="date_picker = false"
                  locale="it-IT"
                  color="secondary"
                  header-color="primary"
                  first-day-of-week="1"
                  show-adjacent-months
                >
                </v-date-picker>
              </v-menu>

              <!-- Download in excel -->
              <v-btn
                icon
                color="primary"
                @click="exportData"
                :disabled="
                  $store.state.tipo_calendario != 'category' ||
                  filteredPrenotazioni.length == 0
                "
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
              <v-select
                label="Filtra per stati"
                v-model="filtro"
                :items="$store.getters.getStatiPrenotazioneAttivi"
                item-value="id_stato"
                item-text="descrizione"
                hide-details
                :multiple="true"
                class="mr-3"
                :clearable="true"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.descrizione }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption ml-2">
                    (+{{ filtro.length - 1 }})
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span
                    >{{ item.descrizione }}
                    <v-icon color="green" v-if="item.opaco"
                      >mdi-check-bold</v-icon
                    >
                    <v-icon color="red" v-else>mdi-close-thick</v-icon>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-btn
              v-blur
              fab
              small
              color="primary"
              @click="openAggiungiPrenotazione"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="primary"
            v-if="loading"
          ></v-progress-linear>
        </v-sheet>
        <v-sheet
          :style="
            $store.state.permessi >= 8 &&
            $store.state.tipo_calendario == 'category'
              ? 'height: calc(100vh - 176px)'
              : 'height: calc(100vh - 128px)'
          "
        >
          <div
            style="padding-left: 60px"
            class="text-center"
            v-if="
              $store.state.permessi >= 8 &&
              $store.state.tipo_calendario == 'category'
            "
          >
            <p class="my-0">Tot. prenotazioni: {{ totPrenotazioni }}</p>
            <p class="my-0">Tot. bancali: {{ totBancali }}</p>
          </div>
          <!-- All'altezza della pagina sottraggo la navbar e la toolbar per navigare nel portale-->
          <v-calendar
            ref="calendar"
            v-model="calendar"
            color="primary"
            :type="
              $store.state.tipo_calendario == ''
                ? 'week'
                : $store.state.tipo_calendario
            "
            :first-time="$store.getters.getFirstTime"
            :interval-count="$store.getters.getIntervalCount"
            :interval-minutes="$store.getters.getIntervalMinutes"
            locale="it-IT"
            :weekdays="weekday"
            :short-weekdays="false"
            :short-intervals="false"
            category-show-all
            :categories="$store.getters.getCategoriesList"
            :events="filteredPrenotazioni"
            :event-color="getEventColor"
            event-overlap-mode="column"
            event-more
            event-more-text="altri..."
            @change="updatePrenotazioni"
            @click:event="showEventPopup"
            :interval-height="$store.getters.getIntervalHeight"
          >
            <template v-slot:day-body="{ date, week }">
              <div
                class="v-current-time"
                :class="{ first: date === week[0].date }"
                :style="{ top: nowY }"
                v-if="$store.state.tipo_calendario == 'week'"
              ></div>
            </template>
            <template v-slot:event="{ event }">
              <span
                class="in-event pa-1"
                :style="`${
                  event['opaco'] == 1 ? 'color: rgb(60,64,67,0.6)' : ''
                }; height: 100%`"
              >
                <strong
                  >{{
                    event["opaco"] == 1 ? `(${event["desc_stato"]}) ` : ""
                  }}N. {{ event["id_prenotazione"] }}</strong
                ><br />
                <span v-if="![2, 4].includes($store.state.permessi)"
                  >{{
                    event["mittente"]
                      ? `${event["rag_soc_cliente"]} - ${event["mittente"]}`
                      : event["rag_soc_cliente"]
                  }}<br
                /></span>
                <span v-if="![1, 3].includes($store.state.permessi)"
                  >{{ event["rag_soc_vettore"] }}<br
                /></span>
                <span v-if="$store.state.permessi >= 8"
                  >{{ event["tipo_scarico"] }}<br
                /></span>
                <span v-if="$store.state.permessi >= 8">{{
                  event["indicazioni_scarico"]
                }}</span>
              </span>
            </template>
          </v-calendar>
          <!--@mouseenter:event="showEventPopup"-->
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog
      v-model="aggiungi_prenotazione_dialog"
      max-width="1000px"
      persistent
      scrollable
    >
      <AggiungiPrenotazione
        ref="aggiungi_prenotazione"
        @close-dialog="aggiungi_prenotazione_dialog = false"
        @update-prenotazioni="updatePrenotazioni()"
      />
    </v-dialog>
    <v-dialog
      v-model="mostra_prenotazione_dialog"
      max-width="1000px"
      persistent
      scrollable
    >
      <MostraPrenotazione
        ref="mostra_prenotazione"
        :prenotazione="dialog_prenotazione"
        @close-dialog="mostra_prenotazione_dialog = false"
        @update-prenotazioni="updatePrenotazioni()"
        @update-dialog-prenotazione="updateDialogPrenotazione"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import AggiungiPrenotazione from "../components/AggiungiPrenotazione.vue";
import MostraPrenotazione from "../components/MostraPrenotazione.vue";
import * as XLSX from "xlsx";

export default {
  data: () => ({
    loading: false,
    weekday: [1, 2, 3, 4, 5, 6, 0],
    mesi: [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre",
    ],
    tipi_calendario: { category: "Comparti", week: "Settimana" },
    date_picker: false,
    calendar: "",
    calendar_date: null,
    events: [],
    prenotazioni: [],
    aggiungi_prenotazione_dialog: false,
    mostra_prenotazione_dialog: false,
    dialog_prenotazione: null,
    promise_clienti: null,
    promise_vettori: null,
    promise_scarichi: null,
    promise_comparti: null,
    promise_stati: null,
    refreshInterval: null,
    updateTimeInterval: null,
    filtro: [],
    totBancali: 0,
    totPrenotazioni: 0,
  }),
  components: {
    AggiungiPrenotazione,
    MostraPrenotazione,
  },
  created() {
    //  Se nello store è vuoto vuol dire che o è stato fatto il refresh o è un nuovo login quindi imposto il default
    if (this.$store.state.tipo_calendario == "") {
      this.$store.state.tipo_calendario =
        this.$store.state.permessi >= 8 ? "category" : "week";
    }
  },
  mounted() {
    this.$store.state.loaded = false;
    var session_filtro = sessionStorage.getItem("filtro");
    if (session_filtro) {
      this.filtro = JSON.parse(session_filtro);
    }

    this.reloadDati();
    this.calendar = this.$store.getters.getCurrentDate;

    Promise.all([
      this.promise_clienti,
      this.promise_vettori,
      this.promise_scarichi,
      this.promise_comparti,
    ]).then(() => {
      this.$store.state.loaded = true;
    });

    //  Funzione per aggiornare la barra rossa del calendario
    this.updateTime();

    this.refreshInterval = setInterval(() => {
      this.reloadDati();
    }, 300000); //  Ogni 5 min aggiorno i dati
  },
  methods: {
    reloadDati() {
      this.loading = true;

      this.promise_clienti = this.$store.dispatch("getClienti").catch((e) => {
        console.log(e);
      });
      this.promise_vettori = this.$store.dispatch("getVettori").catch((e) => {
        console.log(e);
      });
      this.promise_scarichi = this.$store
        .dispatch("getTipiScarico")
        .catch((e) => {
          console.log(e);
        });
      this.promise_comparti = this.$store.dispatch("getComparti").catch((e) => {
        console.log(e);
      });
      this.promise_stati = this.$store
        .dispatch("getStatiPrenotazione")
        .catch((e) => {
          console.log(e);
        });

      this.updatePrenotazioni();
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.calendar = this.$store.getters.getCurrentDate;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    updatePrenotazioni() {
      var start = this.$refs.calendar.lastStart.date;
      var end = this.$refs.calendar.lastEnd.date;

      this.calendar_date = this.$refs.calendar.lastStart;

      //  Calendario di un giorno se admin
      if (this.$store.state.tipo_calendario == "category") {
        end = start;
      }

      if (
        this.promise_clienti != null &&
        this.promise_vettori != null &&
        this.promise_scarichi != null &&
        this.promise_comparti != null &&
        this.promise_stati != null
      ) {
        Promise.all([
          this.promise_clienti,
          this.promise_vettori,
          this.promise_scarichi,
          this.promise_comparti,
          this.promise_stati,
        ]).then(() => {
          this.getPrenotazioni(start, end);
        });
      }
    },
    showEventPopup({ nativeEvent, event }) {
      this.updateDialogPrenotazione(event);
      this.mostra_prenotazione_dialog = true;
    },
    openAggiungiPrenotazione() {
      this.aggiungi_prenotazione_dialog = true;
      this.$nextTick(() => {
        this.$refs.aggiungi_prenotazione.resetForm();
      });
    },
    getPrenotazioni(start, end) {
      this.loading = true;

      var params = {
        da: start,
        a: end,
      };

      this.axios
        .get(
          `${this.$store.state.endpoint}/prenotazioni?${new URLSearchParams(
            params
          ).toString()}`
        )
        .then((response) => {
          this.totPrenotazioni = 0;
          this.totBancali = 0;

          this.prenotazioni = response.data.map((el) => {
            // if (this.$store.state.permessi == 1 || this.$store.state.permessi == 3) {
            //   el["name"] = `Prenotazione n.${el["id_prenotazione"]} - ${el["rag_soc_cliente"]}`;
            // }
            // else if (this.$store.state.permessi == 2 || this.$store.state.permessi == 4) {
            //   el["name"] = `Prenotazione n.${el["id_prenotazione"]} - ${el["rag_soc_vettore"]}`;
            // }
            // else {
            //   el["name"] = `Prenotazione n.${el["id_prenotazione"]} - ${el["rag_soc_cliente"]} - ${el["rag_soc_vettore"]}`;
            // }

            //  Opacizzo colore della prenotazione
            if (el["opaco"]) {
              var colore = el["color"];

              if (colore.length > 7) {
                colore = colore.substr(0, 7);
              }

              var rgb = this.hexToRgb(colore);
              el["color"] = this.RGB_Linear_Shade(
                0.6,
                `rgb(${rgb["r"]}, ${rgb["g"]}, ${rgb["b"]})`
              );
            }

            el["start"] = new Date(`${el["data"]} ${el["ora_inizio"]}`);
            el["end"] = new Date(`${el["data"]} ${el["ora_fine"]}`);
            el["timed"] = true;

            //  Aggiorno il dialog di visualizzazione della prenotazione se aperto
            if (
              this.dialog_prenotazione &&
              this.dialog_prenotazione.id_prenotazione == el.id_prenotazione
            ) {
              this.updateDialogPrenotazione(el);
            }

            return el;
          });

          this.loading = false;
        })
        .catch((e) => {
          this.$store.state.snackbar_text =
            "Non è stato possibile scaricare i dati relativi alle prenotazioni";

          if (
            e.response &&
            e.response.data &&
            e.response.data.message &&
            typeof e.response.data.message === "string"
          ) {
            this.$store.state.snackbar_text += ": " + e.response.data.message;
          }

          this.$store.state.snackbar = true;
          this.$store.state.snackbar_color = "error";
          this.loading = false;
          console.log("Errore prenotazioni", e);
        });
    },
    updateTime() {
      this.updateTimeInterval = setInterval(() => {
        if (this.cal) {
          this.cal.updateTimes();
        }
      }, 60 * 1000);
    },
    updateDialogPrenotazione(el) {
      this.dialog_prenotazione = el;
    },
    // https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
    RGB_Linear_Shade(p, c) {
      var i = parseInt,
        r = Math.round,
        [a, b, c, d] = c.split(","),
        P = p < 0,
        t = P ? 0 : 255 * p,
        P = P ? 1 + p : 1 - p;
      return (
        "rgb" +
        (d ? "a(" : "(") +
        r(i(a[3] == "a" ? a.slice(5) : a.slice(4)) * P + t) +
        "," +
        r(i(b) * P + t) +
        "," +
        r(i(c) * P + t) +
        (d ? "," + d : ")")
      );
    },
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },
    formatOra(val) {
      const ore = Math.floor(val);
      const minuti = Math.round((val - ore) * 60);
      return `${String(ore).padStart(2, "0")}:${String(minuti).padStart(
        2,
        "0"
      )}`;
    },
    generaIntervalli(orarioInizio, orarioFine, intervallo) {
      const intervalli = [];
      for (
        let i = orarioInizio;
        i <= orarioFine - intervallo;
        i += intervallo
      ) {
        const start = i;
        const end = i + intervallo;
        intervalli.push(`${this.formatOra(start)}/${this.formatOra(end)}`);
      }
      return intervalli;
    },
    trovaFasciaOraria(oraInizio, fasce) {
      for (const fascia of fasce) {
        const [fasciaStart, fasciaEnd] = fascia.split("/");
        if (oraInizio >= fasciaStart && oraInizio < fasciaEnd) {
          return fascia;
        }
      }
      return null;
    },
    impostaAltezzaRighe(ws) {
      const BASE_HEIGHT = 20; // Altezza di base in pixel
      const LINE_HEIGHT = 15; // Altezza aggiuntiva per ogni linea di testo

      const range = XLSX.utils.decode_range(ws["!ref"]);
      if (!ws["!rows"]) ws["!rows"] = [];

      // Parti dalla riga 1 (salta intestazione riga 0)
      for (let row = 1; row <= range.e.r; row++) {
        let maxLineCount = 1;

        for (let col = 1; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          const cell = ws[cellAddress];

          if (cell && typeof cell.v === "string") {
            const lineCount = cell.v.split("\n").length;
            if (lineCount > maxLineCount) {
              maxLineCount = lineCount;
            }
          }
        }

        const height = BASE_HEIGHT + (maxLineCount - 1) * LINE_HEIGHT;

        // Applica il tuo codice qui dinamicamente per ogni riga
        if (!ws["!rows"][row]) ws["!rows"][row] = { hpx: height };
        ws["!rows"][row].hpx = height;
      }
    },
    applicaWrapText(ws) {
      const range = XLSX.utils.decode_range(ws["!ref"]);

      for (let R = 1; R <= range.e.r; ++R) {
        // da riga 1 in poi (escludi intestazione)
        for (let C = 1; C <= range.e.c; ++C) {
          // tutte le colonne
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = ws[cellAddress];

          if (cell && typeof cell.v === "string") {
            if (!cell.s) cell.s = {};
            cell.s.alignment = {
              wrapText: true,
              vertical: "top",
            };
          }
        }
      }
    },
    calcolaLarghezzaDinamica(righe) {
      const colWidths = [];

      const numColonne = righe[0].length;

      for (let col = 0; col < numColonne; col++) {
        let maxLen = 10; // lunghezza minima

        for (let row = 0; row < righe.length; row++) {
          const cell = righe[row][col];
          if (cell) {
            const lunghezza = cell
              .toString()
              .split("\n")
              .reduce((max, riga) => Math.max(max, riga.length), 0);
            if (lunghezza > maxLen) maxLen = lunghezza;
          }
        }

        colWidths.push({ wch: maxLen + 2 }); // padding
      }

      return colWidths;
    },
    exportData() {
      // Colonne
      var comparti = this.$store.getters.getCategoriesList;

      // Orari
      var int_inizio = parseInt(this.$store.getters.getFirstTime);
      var int_fine = parseInt(this.$store.getters.getLastTime);
      var fasceOrarie = this.generaIntervalli(
        int_inizio,
        int_fine,
        this.$store.state.ampiezza_fascia
      );

      // Raggruppa eventi per fascia oraria e comparto
      const mappaFasce = {};

      this.filteredPrenotazioni.forEach((evento) => {
        const ora = evento.ora_inizio;
        const fascia = this.trovaFasciaOraria(ora, fasceOrarie);
        if (!fascia) return; // skip se fuori orario

        if (!mappaFasce[fascia]) mappaFasce[fascia] = {};
        if (!mappaFasce[fascia][evento.category])
          mappaFasce[fascia][evento.category] = [];
        mappaFasce[fascia][evento.category].push(evento);
      });

      var righe = [];
      // Intestazione colonne
      righe.push(["Fascia oraria", ...comparti]);

      // Costruisci righe per ogni fascia
      fasceOrarie.forEach((fascia) => {
        const eventiComparto = mappaFasce[fascia] || {};
        const numRighe = Math.max(
          1,
          ...Object.values(eventiComparto).map((e) => e.length)
        );

        for (let i = 0; i < numRighe; i++) {
          const riga = [fascia];
          comparti.forEach((comparto) => {
            const evento = eventiComparto[comparto]?.[i];
            if (evento) {
              var datiEvento = `N. ${evento.id_prenotazione} \n${
                evento.mittente
                  ? `${evento.rag_soc_cliente} - ${evento.mittente}`
                  : evento.rag_soc_cliente
              } \n${evento.tipo_scarico} \n${evento.bancali} pallet`;
              riga.push(datiEvento);
            } else {
              riga.push("");
            }
          });
          righe.push(riga);
        }
      });

      var ws = XLSX.utils.aoa_to_sheet(righe);

      this.applicaWrapText(ws);
      this.impostaAltezzaRighe(ws);
      ws["!cols"] = this.calcolaLarghezzaDinamica(righe);

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Prenotazioni");

      XLSX.writeFile(
        wb,
        `Prenotazioni_${this.filteredPrenotazioni[0].data.replaceAll(
          "-",
          ""
        )}.xlsx`,
        { cellStyles: true }
      );
    },
  },
  computed: {
    cal() {
      return !this.loading ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + "px" : "-10px";
    },
    filteredPrenotazioni() {
      this.totBancali = 0;
      this.totPrenotazioni = 0;
      var filtrate = this.prenotazioni;
      if (this.filtro && this.filtro.length > 0) {
        filtrate = this.prenotazioni.filter((el) =>
          this.filtro.includes(el.stato)
        );
      }

      filtrate.forEach((el) => {
        // Calcolo totale bancali per giorno
        if (this.$store.state.tipo_calendario == "category") {
          this.totBancali += el["bancali"];
        }
      });

      // Calcolo totale prenotazioni per giorno
      if (this.$store.state.tipo_calendario == "category") {
        this.totPrenotazioni = filtrate.length;
      }

      return filtrate;
    },
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
    clearInterval(this.updateTimeInterval);
  },
  watch: {
    filtro() {
      sessionStorage.setItem("filtro", JSON.stringify(this.filtro));
    },
  },
};
</script>

<style lang="scss">
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
.in-event {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}

.v-calendar-category .v-calendar-daily_head-day-label {
  width: 87px;
}

.v-calendar-category .v-calendar-daily_head-day-label .v-btn {
  font-size: 16px;
}

.v-calendar-category .v-calendar-daily_head-weekday {
  font-size: 16px;
  width: 87px;
}
</style>